module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (54).30439ba0.jpg";